import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface FilterBarProps {
  actions?: ReactNode
  children: ReactNode
  className?: string
}

export function FilterBar({ actions, children, className }: FilterBarProps) {
  return (
    <div
      className={cn(
        'relative flex flex-col gap-3 px-5 pt-0 pb-4 lg:flex-row lg:items-center lg:justify-between lg:px-[30px]',
        className,
      )}
    >
      <div className="grid min-w-0 flex-1 grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-[274px_220px_220px]">
        {children}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-3">{actions}</div> : null}
      <div
        aria-hidden
        className="pointer-events-none absolute right-5 bottom-0 left-5 h-px bg-[var(--color-divider-subtle)] lg:right-[30px] lg:left-[30px]"
        data-testid="filter-bar-divider"
      />
    </div>
  )
}
